
import React from "react";
import { Crown } from "lucide-react";
import { cn } from "@/lib/utils";
import { format, parseISO } from "date-fns";
import { useSettings } from "@/context/SettingsContext";
import { getRpgThemeClasses } from "@/lib/utils";
import PerceptiveSystemIcon from "@/components/journal/PerceptiveSystemIcon";
import RpgPerceptiveSystemIcon from "@/components/character/RpgPerceptiveSystemIcon";

interface JournalEntryCardHeaderProps {
  diceValue: number;
  createdAt: string;
  isComplete: boolean;
}

const JournalEntryCardHeader: React.FC<JournalEntryCardHeaderProps> = ({
  diceValue,
  createdAt,
  isComplete
}) => {
  const { darkMode, enableRpgMode } = useSettings();
  const rpgTheme = getRpgThemeClasses(enableRpgMode, darkMode);

  return (
    <div className="flex items-center gap-3">
      {enableRpgMode ? (
        <RpgPerceptiveSystemIcon diceValue={diceValue} size="sm" />
      ) : (
        <PerceptiveSystemIcon diceValue={diceValue} size="sm" />
      )}
      <span className={cn(
        "text-sm opacity-70",
        enableRpgMode && rpgTheme.accent
      )}>
        {createdAt ? format(parseISO(createdAt), "MMM d, yyyy") : ""}
      </span>
      {isComplete && (
        <span className={cn(
          "text-xs px-2 py-1 rounded-full flex items-center gap-1",
          enableRpgMode ? (
            "bg-amber-600 text-amber-100 border border-amber-500/50"
          ) : (
            "bg-green-500 text-white"
          )
        )}>
          {enableRpgMode ? (
            <>
              <Crown className="h-3 w-3" />
              Journey Complete
            </>
          ) : (
            "Unstuck"
          )}
        </span>
      )}
    </div>
  );
};

export default JournalEntryCardHeader;
